import { IField, IReflect } from 'app/services/api5-service/api.interface';
import { map } from 'rxjs/operators';

import { ReflectProps } from './model/reflect-props.interface';

import {
  ISPFieldConfig,
  ISPFieldType,
  ISPFieldWrapper,
  ISPFormState,
} from '../../model';
import { getCheckboxCaptions$ } from '../checkbox/checkbox.utils';

/**
 * Get props for reflect field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getReflectProps(
  control: IReflect,
  field: IField,
  state: ISPFormState,
): ReflectProps {
  const captions$ = getCheckboxCaptions$(field, state);

  return {
    originalControl: control,
    originalField: field,
    fieldSettings$: captions$.pipe(map(({ fieldSettings }) => fieldSettings)),
    captions$,
    watchFor: (control.$reflect || '')
      .split(',')
      .map(name => name.trim())
      .filter(Boolean),
    labelPosition: control.$msg_side,
  };
}
/**
 * Get config for reflect field
 *
 * @param control - control (subfield) metadata
 * @param field - field metadata
 * @param state - dynamic form state
 */
export function getReflectConfig(
  control: IReflect,
  field: IField,
  state: ISPFormState,
): ISPFieldConfig<ISPFieldType.Reflect> {
  const props = getReflectProps(control, field, state);

  const config: ISPFieldConfig<ISPFieldType.Reflect> = {
    type: ISPFieldType.Reflect,
    wrappers: [ISPFieldWrapper.FieldBase],
    props,
  };

  return config;
}
